<template>
  <div class="video-page-wrapper">
    <div style="display: flex; flex-direction: row">
      <img style="max-height: 60vh; height: 100%; margin-right: 10px; max-width: 47%" src="@/assets/pages/alarm-system.png" alt="img" />
      <img style="max-height: 60vh; height: 100%; max-width: 47%" src="@/assets/pages/alarm-system-2.png" alt="img" />
    </div>
    <PageTabs>
      <template v-slot:first>
        <div>
          <div class="video-page-texts video-page-texts-no-offset">
            <div>
              <h3>{{ $t("pages.alarm-systems.subtitle1") }}</h3>
              <p>{{ $t("pages.alarm-systems.text1") }}</p>
            </div>
          </div>
          <ProductsRow :products="products"></ProductsRow>
        </div>
      </template>
      <template v-slot:second>
        <VoiceCommands :commands="commands"></VoiceCommands>
      </template>
    </PageTabs>
  </div>
</template>

<script>
import PageTabs from "../components/PageTabs";
import VoiceCommands from "../components/VoiceCommands";
import ProductsRow from "../components/ProductsRow";
export default {
  name: "AlarmSystems",
  components: { ProductsRow, VoiceCommands, PageTabs },
  data() {
    return {
      commands: this.$t("pages.alarm-systems.commands"),
      products: [
        { img: "security/security-lyric.png", text: "Honeywell Lyric", price: "" },
        { img: "security/security-abode.png", text: "Abode", price: "" },
        { img: "security/security-dsc.png", text: "DSC", price: "" }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.img-music {
  width: 100%;
  max-width: 200px;
}
</style>
